
import { useContext, useRef } from "react";
import { useSelector } from "react-redux";
import { WorkspaceShowContext } from "../../contexts/WorkspaceShowContext";
import useAssignedUserPopupHook from "./useAssignedUserPopupHook";
import { useSafePosition } from "../../utils/useSafePosition";
import AssignedUserForm from "../../App/screens/AssignedUserPage/form";
import { useMediaQuery } from "react-responsive";
import AssignedUserPopupModal from "./AssignedUserPopupModal";
import { mediaQueryConstants } from "../../constants";

function AssignedUserPopup ({
}) {
    const popupRef = useRef(null);
    const isLargeScreen = useMediaQuery({ query: `(max-width: ${mediaQueryConstants.LARGE}px)` });

    const { 
        isOpenParticipantModal, 
        boundary,
        content_group_id 
    } = useSelector(state => state.participant_popup);
    const {
        workspace_id,
    } = useContext(WorkspaceShowContext);
    const {
        participant_user_options,
        assigned_users,
        assigned_users_object
    } = useSelector(state => state.assigned_user);
    const {
        onSubmit,
        closeDropDownPopup
    } = useAssignedUserPopupHook({
        content_group_id,
        workspace_id,
        popupRef
    });
    const position = useSafePosition({
        initialTop: boundary.top,
        initialLeft: boundary.left,
        sourceWidth: boundary.width,
        sourceHeight: boundary.height ,
        width: popupRef.current ? popupRef.current.offsetWidth : 0,
        height: popupRef.current ? popupRef.current.offsetHeight : 0
    });

    if (!isOpenParticipantModal) {
        return null;
    }   

    if(isLargeScreen){
        return (
            <AssignedUserPopupModal 
               onSubmit={onSubmit}
                workspace_id={workspace_id}
                content_group_id={content_group_id}
                participant_user_options={participant_user_options}
                assigned_users={assigned_users}
                assigned_users_object={assigned_users_object}
                closeDropDownPopup ={closeDropDownPopup}
                onHide={closeDropDownPopup}
                show={isOpenParticipantModal}
            />
        )
    }

    return(
        <nav
            ref={popupRef}
            className={`assigned_user_list box-shadow  ${isOpenParticipantModal ? "active" : "inactive"}`}
            id="new_assigned_user_list"
            style={{
                left: position.left,
                top: position.top,
                zIndex: 1000,
                position: 'absolute'
            }}
        >
            <div className="assigned-users-popup__container">
                <AssignedUserForm
                    onSubmit={onSubmit}
                    workspace_id={workspace_id}
                    content_group_id={content_group_id}
                    participant_user_options={participant_user_options}
                    assigned_users={assigned_users}
                    assigned_users_object={assigned_users_object}
                    closeDropDownPopup ={closeDropDownPopup}
                />
            </div>
        </nav>
    )
}

export default AssignedUserPopup;